var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      !_vm.editSettings && !_vm.settings
        ? _c("app-stored-settings", {
            attrs: { service: _vm.service },
            on: {
              close: function ($event) {
                return _vm.close()
              },
              settings: function ($event) {
                _vm.settings = $event
              },
              "edit-settings": function ($event) {
                _vm.editSettings = $event
              },
            },
          })
        : _vm.editSettings
        ? _c("app-settings-editor", {
            attrs: {
              service: _vm.service,
              settings: _vm.editSettings,
              "allowed-output-headers": _vm.allowedOutputHeaders,
            },
            on: {
              close: function ($event) {
                return _vm.closeSettingsEditor()
              },
              settings: function ($event) {
                _vm.editSettings = $event
              },
              file: function ($event) {
                return _vm.onExcelFileCreated(
                  $event,
                  _vm.editSettings.Settings.ExtraData
                )
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "extra-settings",
                  fn: function (slotProps) {
                    return [
                      _vm._t("extra-settings", null, {
                        settings: slotProps.settings,
                      }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm.settings
        ? _c("app-excel-mapper-runner", {
            attrs: { settings: _vm.settings },
            on: {
              close: function ($event) {
                return _vm.close()
              },
              file: function ($event) {
                return _vm.onExcelFileCreated(
                  $event,
                  _vm.settings.Settings.ExtraData
                )
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }